import { render, staticRenderFns } from "./CardLarge.vue?vue&type=template&id=4bc75668&scoped=true&"
import script from "./CardLarge.vue?vue&type=script&lang=js&"
export * from "./CardLarge.vue?vue&type=script&lang=js&"
import style0 from "./CardLarge.vue?vue&type=style&index=0&id=4bc75668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc75668",
  null
  
)

export default component.exports